<template>
  <div>
    <app-history @clicked="$router.push('/transfer-history')" />
    <v-card class="fullForm">
      <div class="fullText">
        <ul>
          <li>
            شما مي توانيد چند مدرسه را به عنوان مدرسه مقصد انتخاب نماييد و هریک
            از درخواست ها که زودتر نهائی شد، بقيه ‏درخواست های انتقال شما کان لم
            یکن تلقی مي گردد، لذا نسبت به انتخاب مدرسه مقصد دقت فرماييد.(طلاب
            خواهر تنها مجاز به انتخاب يك مدرسه هستند)‏
          </li>
          <li>
            شما مي توانيد قبل از تاييد درخواست انتقال خود مستندات وتوضيحات خود
            را ضميمه نماييد.
          </li>
          <li>
            درخواست شما پس از ارسال بترتيب به رويت مسئول آموزش مدرسه مبدا، مسئول
            آموزش مدرسه مقصد، مسئولان نمايندگي و ‏يا مركز مديريت خواهد رسيد‎.‎
          </li>
          <li>
            در صورتيكه همه ي مسئولان ذيربط فوق الذكر با درخواست شما موافقت
            نمايند، بصورت سيستمي مدرسه شما تغيير خواهد ‏كرد و در صورت عدم تاييد
            انتقالي صورت نمي گيرد .
          </li>
          <li>
            ‏زمان درخواست نقل و انتقال براي طلاب مدارس علميه سطح يك(برادران) از
            اول مرداد تا 22 شهريورماه خواهد بود و به ‏درخواستهاي بعد از این
            تاريخ ترتيب اثر داده نخواهد شد.
          </li>
          <li>
            جهت انتقال از مدارس علميه شهرستانها به مدارس علميه مشهد (برادران) مي
            بايست پايه 3 طلبه تكميل باشد‎، در غیر اینصورت در خواست در کمیسیون
            نیز مطرح و در صورت موافقت کمیسیون و مدرسه مقصد، انتقال صورت می گیرد.
            (فرصت زمان درخواست جهت معرفي به كميسيون نقل و انتقالات طلاب مدارس
            علميه سطح يك (برادران ) حداكثر 10 شهریورماه خواهد بود و نتايج آن
            25 شهريورماه اعلام خواهد شد.) ‎
          </li>
          <li>
            شما مي توانيد در بخش مشاهده سوابق اقدام به پيگيري درخواست خود
            نمائيد.
          </li>
          <li>
            در صورتي كه تذكرات فوق را مطالعه نموده ايد و قصد انتقال به مدرسه
            ديگر در استان را داريد، دكمه‎ درخواست انتقال ‎‎را كليك نموده و
            ‏مراحل انتقال را تا آخر طي نمائيد‎.‎
          </li>
          <li>
            در صورتیکه قصد دارید به مدارس قم یا تابعه ی مرکز مدیریت قم (همه ی
            استان ها بجز اصفهان) انتقال یابید، لینک انتقال به قم را کلیک فرمائید
          </li>
        </ul>
        <br />
      </div>
      <v-row class="ltr">
        <v-btn color="primary white--text" class="request" rounded @click="$router.push('/transfer-qom')">
          انتقال به قم و استان های تابعه
        </v-btn>
        <v-btn color="primary white--text" class="request" rounded @click="$router.push('/transfer-ostan')">
          انتقال درون استان
        </v-btn>
      </v-row>
    </v-card>
  </div>

</template>

<script>
import { requestMorkhasi } from "@/api/morkhasi";
import { TODAY } from "@/utils/constants";
import HistoryButton from "@/components/HistoryButton";
import moment from "moment-jalaali";
export default {
  data() {
    return {
      today: TODAY,
      startDate: TODAY,
      endDate: TODAY,
      startSelected: false,
      endSelected: false,

      image: null,
      morkhasiType: "",
      comment: "",
    };
  },
  components: {
    appHistory: HistoryButton,
  },
  methods: {
    onClickDate(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },
    onChangeDate($event, input) {
      let date = moment($event).format("jYYYY/jMM/jDD");
      if (input == 1) {
        this.startDate = date;
        this.startSelected = true;
      } else {
        this.endDate = date;
        this.endSelected = true;
      }
    },
    /**
     * check user input and  then send khorooj request
     */
    applyRequest() {
      var text = "";
      if (!this.startSelected) {
        text = "لطفا زمان شروع را انتخاب کنید.";
      } else if (!this.endSelected) {
        text = "لطفا زمان پایان را انتخاب کنید.";
      } else if (this.startDate > this.endDate) {
        text = "زمان شروع بایستی پیش از زمان پایان باشد.";
      } else if (this.morkhasiType == "") {
        text = "نوع مرخصی انتخاب نشده است.";
      } else if (this.morkhasiType == "14" && this.image == null) {
        text = "جهت مرخصی بدون احتساب سنوات، پیوست مستندات ضروری می باشد.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        requestMorkhasi(
          this.image,
          this.startDate,
          this.endDate,
          this.morkhasiType,
          this.comment
        )
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

            if (data.Success) {
              this.goToIndex();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
    goToIndex() {
      this.$router.push({ path: "/index" });
    },
  },
  /**
   * get khorooji meta data
   */
  created() {
    this.$store.dispatch("getMorkhasiInfo");
  },
  computed: {
    morkhasiInfo() {
      return this.$store.getters.morkhasiInfo;
    },
  },

};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}

.v-textarea {
  height: 100% !important;
}

.request {
  width: 300px !important;
  margin: 15px;
}

.register {
  width: 300px !important;
  margin: 15px auto;
}

@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>
